export enum Status {
  Approved = 'APPROVED',
  AutoApproved = 'AUTO-APPROVED',
  Cancelled = 'CANCELLED',
  Active = 'ACTIVE',
  Future = 'FUTURE',
  Declined = 'DECLINED',
}
